import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownModule } from '../dropdown/dropdown.module';
import { ButtonModule } from '../button/button.module';
import { OnlyIntegerNumberModule } from 'shared/only-integer-number/only-integer-number.module';

import { PaginationSimplifiedComponent } from './pagination-simplified/pagination-simplified.component';
import { GenericPaginationComponent } from './generic-pagination/generic-pagination.component';
import { GenericPaginationV2Component } from './generic-pagination-v2/generic-pagination-v2.component';
import { SimplePaginationComponent } from './simple-pagination/simple-pagination.component';


@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    ButtonModule,
    OnlyIntegerNumberModule,
  ],
  declarations: [
    PaginationSimplifiedComponent,
    GenericPaginationComponent,
    SimplePaginationComponent,
    GenericPaginationV2Component,
  ],
  exports: [
    CommonModule,
    ButtonModule,
    PaginationSimplifiedComponent,
    GenericPaginationComponent,
    SimplePaginationComponent,
    GenericPaginationV2Component,
  ]
})
export class PaginationModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: PaginationModule,
      providers: []
    };
  }
}
